<template>
  <transition name="el-fade-in">
  <div class="list" v-if="isShow" v-bar :style="componentStyle"
    v-loading="isRequesting"
    element-loading-text="加载中..."
    element-loading-spinner="el-laihua-loading"
  >
    <div>
      <ul :style="contentPaddingStyleComputed" v-if="!isShowEmpty" style="width: 240px; margin-left: 14px">
        <!-- @mouseenter="playLottie(i)"
        @mouseleave="playLottie(i, false)" -->
        <li v-for="(item, i) in motions" :key="i" ref="item"
          @mouseenter="playLottie(i)"
          @mouseleave="playLottie(i, false)"
          @click="selectItem(i)"
          :class="{'is-selected': item.selected}"
        >
          <div v-if="!isAnimatedImage" class="list__lottie-wrapper" ref="wrapper" v-show="item.instance">
          </div>
          <!-- <div class="list__lottie-wrapper is-error" v-show="!item.isLoaded"><span>{{item.msg}}</span></div> -->
          <div v-if="!isAnimatedImage" class="list__lottie-wrapper" v-show="!item.instance">
            <img v-show="!motionGenerating && !isRequesting" ref="thumbnailRef" :src="item.thumbnail" alt="" @load="onImgLoad($event)">
          </div>
          <div v-if="isAnimatedImage" class="list__lottie-wrapper gif" v-show="!item.instance">
            <img ref="thumbnailRef" :src="item.thumbnail" alt="" @load="onImgLoad($event)">
            <img ref="thumbnailRef" :src="item.options.path" alt="" @load="onImgLoad($event)">
          </div>
          <div class="list__item-caption">{{item.caption}}</div>
        </li>
      </ul>
      <div class="empty" v-if="isShowEmpty">
        <i class="icon-laihua-air"></i>
        <div>空空如也~</div>
      </div>
    </div>
  </div>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex';
import getNavType from '@/components/mixins/getNavType';

// eve.on('editor.spriteSwapped', (newSprite) => {
//   window.TOOL.selectSprite([newSprite]);
// });

export default {
  name: 'lottieMotionContent',
  mixins: [ getNavType ],
  props: {
    componentHeight: {
      type: [Number, String],
      default: 220
    },
    contentPaddingStyle: {
      type: Object,
      default () {
        return {
          paddingTop: 0,
          paddingBottom: '14px'
        }
      }
    },
    isShow: {
      type: Boolean,
      default: true
    },
    popupName: {
      type: String,
      default: 'setting_Lottie'
    },
    motionGenerating: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      motions: [],
      lottieInstances: [],
      isRequesting: true,
      loading: null,
      isShowEmpty: false,
      motionChanging: false,
    }
  },
  computed: {
    ...mapGetters([
      'TOOL',
      'SelectScenes_Msg',
      'SelectSprites_Msg'
    ]),
    sprite () {
      return this.SelectSprites_Msg[0] || {}
    },
    componentStyle () {
      return {
        height: typeof this.componentHeight === 'number' ? this.componentHeight + 'px' : this.componentHeight
      }
    },
    contentPaddingStyleComputed () {
      return {
        paddingTop: 0,
        paddingBottom: '14px',
        ...this.contentPaddingStyle
      }
    },
    isAnimatedImage () {
      return [57, 100, 118].includes((this.item || {}).fileType);
    }
  },
  watch: {
    isShow: {
      handler (val, old) {
        // if (val && this.motions && !this.motions.length || val && !isSame) {
        if (val && !this.motionChanging) {
          this.motions = [];
          this.getData();
        }
        this.motionChanging = false;
      }
    }
  },
  created () {
    eve.on('editor.spriteSwapped', (newSprite) => {
      this.TOOL.selectSprite([newSprite]);
    });

    // this.motions.length || this.getData();
    // console.log('lottieMotionContent created')
    this.$bus.on('lottieMotion.clear', () => {
      this.lottieInstances.forEach((item) => {
        item && item.renderer && item.destroy();
      });
      this.motions.forEach((item) => {
        let instance = item.instance;
        instance && instance.renderer && instance.destroy();
        item.instance = instance = null;
      });
      this.lottieInstances = [];
    });
  },
  mounted () {

  },
  methods: {
    // 从服务器获取lottie数据
    getData () {
      if (!this.SelectSprites_Msg[0]) {
        // throw new Error('no current lottie sprite');
        return;
      }
      let navType = this.getNavType();
      console.log(`Turbo ~ getData ~ navType`, navType)
      if (navType !== 'characters') {
        this.getNotCharacters({
          navType
        });
        return;
      }
      this.isRequesting = true;
      let getting = Promise.resolve();
      const sprite = this.SelectSprites_Msg[0];
      if ([57, 100].includes(sprite.option.fileType)) {
        console.log(`Turbo ~ getData ~ sprite`, sprite)
        getting = this.$http.get('/api/user/chartlet/getAction', {
          params: {
            // id: this.SelectSprites_Msg[0].option.resourceId || localStorage.getItem('character-id'),
            actionId: sprite.option.resourceId,
            sceneId: 6
          }
        });
      } else {
        getting = this.$http.get('/api/common/character/actions', {
          params: {
            id: this.SelectSprites_Msg[0].option.resourceId || localStorage.getItem('character-id'),
          }
        });
      }

      getting
        .then(({data: resData} = {}) => {
          let {code, data} = resData;
          // console.log(data, '<-- lottie motion data')
          if (!data) {
            this.handleDataNull({
              responseCode: code
            });
            return;
          }
          data && this.createMotions(data);
          this.$nextTick(() => {
            // Promise.resolve()
            //   .then(() => {
            //     this.initLotties();
            //   })
            //   .catch(err => console.warn(err))
            this.timeoutTask();
            this.highlightMotion();
            if (code == 200) {
              this.isRequesting = false;
            }
          })
        })
    },

    handleDataNull ({
      responseCode
    } = {}) {
      this.isShowEmpty = true;
      let filename = this.SelectSprites_Msg[0].option.url;
      if (filename) {
        let m = this.createMotion({
          actionId: this.SelectSprites_Msg[0].option.resourceId,
          caption: '',
          path: filename,
          thumbnail: ''
        });
        this.motions.push(m);
      }

      this.$nextTick(() => {
        this.emitSelectItemLottie(0);
        if (responseCode == 200) {
          this.isRequesting = false;
        }
      });
    },

    // 获取不是角色分类的lottie
    getNotCharacters ({
      navType
    } = {}) {
      let map = {
        props: 17,
        shapes: 15,
      }
      this.$http.get('/api/common/material', {
        params: {
          type: map[navType],
          id: this.SelectSprites_Msg[0].option.resourceId
        }
      })
        .then(({data: resData} = {}) => {
          let {code, data} = resData;
          // console.log(data, '<-- not character lottie')
          if (!data) {
            this.handleDataNull({
              responseCode: code
            });
            return;
          }
          let motion = this.createMotion({
            actionId: data.id,
            caption: data.title,
            path: data.url,
            thumbnail: data.thumbnailUrl
          });
          let lottieInstance = lottie.loadAnimation(motion.options);
          // this.lottieInstances = [lottieInstance];
          this.$emit('selectItem', {
            lottieInstance,
            url: motion.thumbnail
          });

          this.$bus.once('lottieMotion.clear', () => {
            lottieInstance && lottieInstance.renderer && lottieInstance.destroy();
            lottieInstance = null;
          })
        })
    },
    createMotions (arr) {
      if (!arr) {
        return;
      }
      arr.forEach((item) => {
        if (item.dataUrl) {
          item.url = item.dataUrl.replace(/\.webm$/i, '_web.apng');
          item.fileType = item.fileType || 57;
        }
        let motion = this.createMotion({
          actionId: item.id,
          caption: item.title,
          path: item.url,
          thumbnail: item.thumbnailUrl,
          fileType: item.fileType
        });
        this.motions.push(motion);
      });
      if (this.motions.length) {
        this.isShowEmpty = false;
      }
    },
    createMotion ({
      actionId,
      caption,
      path,
      thumbnail,
      fileType
    } = {}) {
      path = this.$handleAssetsUrl(path);
      thumbnail = this.$handleAssetsUrl(thumbnail);
      return {
        actionId,
        caption,
        selected: false,
        isLoaded: false,
        msg: '加载中...',
        thumbnail,
        fileType,
        options: {
          container: document.createElement('div'),
          renderer: 'svg',
          loop: true,
          autoplay: false,
          // path: '/static/animengine/renwu.json'
          path,
        }
      }
    },
    highlightMotion () {
      const vm = this;
      vm.motions.some((item, i) => {
        let isFound = item.actionId === vm.sprite.option.resourceId;
        if (isFound) {
          vm.$set(item, 'selected', true);
          vm.emitSelectItem(i);
        }
        return isFound;
      })
    },

    // 提示lottie生成失败，例如接收到的lottie json 是404 或格式有误
    timeoutTask () {
      setTimeout(() => {
        this.motions.forEach((item) => {
          if (!item.isLoaded) {
            item.msg = '呃哦，未找到'
          }
        })
      }, 1000)
    },

    // 创建lottie实例
    initLotties () {
      const vm = this;
      let items = this.$refs.item || [];
      this.lottieInstances = items.map((item, i) => {
        let opts = vm.motions[i].options;
        opts.container = item.children[0];
        let instance = lottie.loadAnimation(opts);

        // lottie json 404错误不会触发这个事件
        instance.addEventListener('DOMLoaded', (e) => {
          this.motions[i].isLoaded = instance.isLoaded;
          if (!instance.isLoaded) {
            this.motions[i].msg = '呃哦，未找到';
          } else {
            this.motions[i].msg = '加载成功';
          }
        });
        this.$set(this.motions[i], 'instance', instance);

        return instance;
      })
    },
    initLottie (index, {
      autoplay = false,
    } = {}) {
      let items = this.$refs.item || [];
      let item = items[index];
      // item.children[0].style.display = '';
      let o = {
        ...this.motions[index].options,
        container: item.children[0],
        autoplay
      };
      return lottie.loadAnimation(o);
    },
    playLottie (index, shouldPlay) {
      let instance = this.motions[index].instance
      if (!instance) return;
      if (shouldPlay === false) {
        instance && instance.stop();
        // instance && instance.renderer && instance.destroy();
        // this.motions[index].instance = instance = null;
        return;
      }
      if (instance) {
        instance.play();
      } else {
        this.$set(this.motions[index], 'instance', this.initLottie(index, {
          autoplay: true
        }));
      }
      // this.motions[index].instance && this.motions[index].instance.play();
    },
    playLottie_ (index, shouldPlay) {
      const lotties = this.lottieInstances;
      if (shouldPlay === false) {
        lotties[index] && lotties[index].stop();
        return;
      }
      lotties[index] && lotties[index].play();
    },
    selectItem (index) {
      const vm = this;
      if (
        !this.SelectSprites_Msg ||
        !this.SelectSprites_Msg[0] ||
        this.motions[index].actionId === this.SelectSprites_Msg[0].option.resourceId
      ) {
        return;
      }
      // if (!this.lottieInstances[index].isLoaded) {
      //   return;
      // }
      this.motions.forEach((item, i) => {
        if (i === index) {
          vm.$set(item, 'selected', true);
          this.onSelectItem(i);
        } else {
          vm.$set(item, 'selected', false);
        }
      });
    },
    emitSelectItem (index) {
      let el = document.createElement('div');
      let opts = {
        ...this.motions[index].options,
        container: el
      };
      let lottieInstance = lottie.loadAnimation(opts);
      this.$bus.once('lottieMotion.clear', () => {
        lottieInstance && lottieInstance.renderer && lottieInstance.destroy();
        lottieInstance = null;
      });
      let url = this.motions[index].thumbnail;
      this.$emit('selectItem', {
        lottieInstance,
        url
      });
    },
    emitSelectItemLottie (index) {
      let el = document.createElement('div');
      let opts = {
        ...this.motions[index].options,
        container: el
      };
      let lottieInstance = lottie.loadAnimation(opts);
      this.$bus.once('lottieMotion.clear', () => {
        lottieInstance && lottieInstance.renderer && lottieInstance.destroy();
        lottieInstance = null;
      });
      // let url = this.motions[index].thumbnail;
      this.$emit('selectItem', {
        lottieInstance,
        // url
      });
    },
    onSelectItem (index) {
      // this.emitSelectItem(index);

      // console.log(this.sprite, this.motions[index].options.path)
      // this.sprite.setOption({
      //   isUpdate: true,
      //   lottieOptions: {
      //     path: this.motions[index].options.path
      //   }
      // })

      this.$store.commit('save_IsPreventClick', true);
      let sprite = this.SelectSprites_Msg[0];
      let spriteOptions = {
        sprite,
        typeForAdd: 'Lottie',
        optionForAdd: {
          lottieOptions: {
            path: this.motions[index].options.path,
            loop: 4,
            autoplay: true,
          },
          resourceId: this.motions[index].actionId,
          actionId: this.motions[index].actionId,
          fileType: this.motions[index].fileType
        },
        options: {
          type: 'motion'
        }
      };
      if (sprite.type === 'Gif') {
        spriteOptions = {
          sprite,
          typeForAdd: 'Gif',
          optionForAdd: {
            url: this.motions[index].options.path,
            resourceId: this.motions[index].actionId, // 资源id
            fileType: this.motions[index].fileType, // 资源type
            isLoop:
              typeof sprite.isLoop === "boolean"
                ? sprite.isLoop
                : sprite.option.isLoop,
            numberOfLoops: sprite.numberOfLoops,
          }
        }
      }
      this.TOOL.swapSprite(spriteOptions, true)
        .then(() => {
          this.motionChanging = true;
          this.$bus.emit('FeaturesPop_vue', {
            name: this.popupName,
            sprite: this.sprite,
            type: 1
          })
          setTimeout(() => {
            this.$store.commit('save_IsPreventClick', false);
            // this.$bus.emit('FeaturesPop_close_vue',{
            //   name : 'motion_Lottie',
            //   type : 1
            // });
          }, 2000);
        })
        .catch(() => {
          this.$store.commit('save_IsPreventClick', false);
        })

      // this.$bus.emit('FeaturesPop_close_vue',{
      //   name : 'setting_Lottie',
      //   type : 1
      // });
    },

    onImgLoad (ev) {
      let el = ev.target;
      let { naturalHeight, naturalWidth } = el;
      if (naturalHeight >= naturalWidth) {
        el.style.width = 'auto';
        el.style.height = '100%';
      } else {
        el.style.width = '100%';
        el.style.height = 'auto';
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../style/colors.scss";

.list {
  width: 258px;
  overflow-y: hidden;
  &__lottie-wrapper {
    width: 70px;
    height: 70px;
    margin: 0 auto 8px;
    border-width: 2px;
    border-style: solid;
    border-color: transparent;
    border-radius: 8px;
    background-color: $c4;
    &.is-error {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &>img {
      width: 100%;
      height: 100%;
    }
    &.gif {
      & > img {
        &:first-child {
          display: initial;
        }
        &:nth-child(2) {
          display: none;
        }
      }
      &:hover > img {
        &:first-child {
          display: none;
        }
        &:nth-child(2) {
          display: initial;
        }
      }
    }
  }
  >div {
    display: flex;
    justify-content: center;
  }
  >div>ul {
    // overflow-y: auto;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    width: 220px;
    // max-height: 220px;
    margin-left: 20px;
    margin-right: auto;
    width: 230px;
    >li {
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: 70px;
      height: 100px;
      cursor: pointer;
      margin-top: 10px;
      margin-right: 10px;

      &.is-selected {
        .list__lottie-wrapper {
          border-width: 2px;
          border-style: solid;
          border-color: #5779fa;
        }
      }

      &:nth-child(1), &:nth-child(2), &:nth-child(3) {
        margin-top: 0;
      }

      &:nth-child(3n) {
        margin-right: 0;
      }

      &:hover {
        >.list__lottie-wrapper {
          border-style: solid;
          border-color: #5779fa;
        }
      }
    }
  }

  >div>.empty {
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
    align-items: center;
    & > div {
      margin-top: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/popups/content/lottieMotionContent.vue